export default __webpack_public_path__ + "static/media/IMG_2465.eb03f160.jpg";